import { createEntityAdapter } from '@ngrx/entity';
import { PatrimoineAncetreEntityState } from '@get/api-interfaces';
import { CustomEntityState } from '@get/store/configs/states';

export type IState = CustomEntityState<PatrimoineAncetreEntityState>;

export const adapter = createEntityAdapter<PatrimoineAncetreEntityState>({
  selectId: o => o.idPatrimoineAncetre
});
export const initialState: IState = adapter.getInitialState({
  isLoaded: false,
  isLoading: false,
  actives: []
});

export const patrimoineAncetreFeatureKey = 'patrimoineAncetre';
